import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { CryptoJsService } from "./crypto-js.service";
import { Router } from "@angular/router";
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private readonly localStorage: CryptoJsService, private routes: Router) { }

  async confirmDialogSwal(title: string, text: string): Promise<'ok' | 'cancel'> {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si',
    cancelButtonText: 'Cancelar',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false
  });

  return result.isConfirmed ? 'ok' : 'cancel';
}


  async sinoDialogSwal(title: string, text: string): Promise<any> {
    return new Promise(async (resolve) => {
      await Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,  // Muestra el botón de "Cancelar"
        showDenyButton: true,    // Muestra el botón de "No"
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        denyButtonColor: "#ffc107", // Color del botón "No"
        confirmButtonText: "Si",
        denyButtonText: "No",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false, // No permite cerrar haciendo clic fuera
        allowEscapeKey: false,    // No permite cerrar con la tecla Escape
        allowEnterKey: false,     // No permite cerrar con la tecla Enter
      }).then((result) => {
        if (result.isConfirmed) {
          resolve('ok');  // El usuario hizo clic en "Sí"
        } else if (result.isDenied) {
          resolve('no');  // El usuario hizo clic en "No"
        } else if (result.isDismissed) {
          resolve('cancel');  // El usuario hizo clic en "Cancelar" o cerró el diálogo
        }
      });
    });
  }
  


  async okDialogSwal(title: string, text: string): Promise<any> {
    return new Promise(async (resolve) => {

      await Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false, // No permite cerrar haciendo clic fuera del diálogo
        allowEscapeKey: false,    // No permite cerrar con la tecla Escape
        allowEnterKey: false,     // No permite cerrar con la tecla Enter
      }).then((result) => {
        if (result.isConfirmed) {
          resolve('ok');
        }
      });

    });
  }


  succesDialogSwal(tittle: string) {
    Swal.fire({
      position: "center",
      icon: "success",
      title: tittle,
      showConfirmButton: false,
      timer: 2000
    });
  }

  dialogErrorSwal(tittle: string) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: tittle,
      showConfirmButton: false,
      timer: 2500
    });

  }

  async confirmacionMessage(title: string, text: string): Promise<any> {
    return new Promise(async (resolve) => {

      await Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Salir",
        allowOutsideClick: false, // No permite cerrar haciendo clic fuera del diálogo
        allowEscapeKey: false,    // No permite cerrar con la tecla Escape
        allowEnterKey: false,     // No permite cerrar con la tecla Enter
      }).then((result) => {
        if (result.isConfirmed) {
          resolve('ok');

        }
      });

    });
  }
}
